import React, {useContext, useMemo} from 'react';
import {Tooltip} from 'antd';
import {AuditMarkingContext} from '../../../../context';
import * as actiontypes from '../../../..//reducer/action';
import '../TagListManager.less';
// 渲染标签组的方法
const RenderListItem = ({tags = [], item}) => {
	const {state, dispatch} = useContext(AuditMarkingContext);
	const newTags = [...tags];
	newTags.unshift({word: '其他'});
	newTags.unshift({word: '实体'});
	newTags.push({word: '新增标签'});
  const deleteTag = (item, t) => {
    const n = item.newTags;
    let length = n.length;
    for (let i = 0; i < length; i ++) {
      if ((n[i].id === t.id) && (n[i].parentId === t.parentId)) {
    //   if ((n[i].id === t.id)) {
        n.splice(i, 1);
				length--;
				i--;
      }
    }
    if (n.length === 0) {
      delete item.newTags;
    }
    dispatch({
      type: actiontypes.setData,
      data: {
        insGroup: [...state.insGroup],
      }
    })
  }
	const wrapperDev = (item, t, style, toolTipTitle, flag) => {
		return (
			<div 
				key={new Date().getTime() + '' + t.id} 
				style={style}
			>
				<Tooltip title={toolTipTitle}>{t.word}</Tooltip>
				{!flag && (
					<Tooltip title='删除该标签'>
						<div className='newTagCross' onClick={() => deleteTag(item, t)}>×</div>
					</Tooltip>
				)}
			</div>
		);
	};
	const renderTags = (flag = true, index) => {
		// true 渲染旧标签，false 渲染新标签
		const tagName = flag ? 'oldTags' : 'newTags';
		return item?.[tagName]?.length > 0 // 是否有对应标签并且对应标签数组长度大于 0
			? item[tagName].map((t) => {
					const style = {
						color: 'white',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						cursor: 'default',
						backgroundColor: flag ? 'rgb(135, 208, 104)' : 'rgb(16, 142, 233)',
					};
					const toolTipTitle = flag ? '旧标签' : '新标签';
					if (t.type === 1 && index === 0) {
						// 如果是实体，则放在实体中
						return wrapperDev(item, t, style, toolTipTitle, flag);
					} else if (t.type === 2 && index === newTags.length - 1) {
						// 如果是新增标签，则放在最后
						return wrapperDev(item, t, style, toolTipTitle, flag);
					} else {
						// 其他按照对应的父级id进行放置
						const i = tags.findIndex((v) => {return v.word === t.style});
						if (i === -1) {
							if (t.type === 0 && index === 1) {
								return wrapperDev(item, t, style, toolTipTitle, flag)
							}
							return null;
						}
						return (i + 2) === index
							? wrapperDev(item, t, style, toolTipTitle, flag)
							: null;
					}
			  })
			: null;
	};
	return useMemo(
		() =>
			newTags.map((v, index) => (
				<li key={index} style={{ width: index === 11 || index === 12 ? '148px' : '120px'}}>
					{/* 渲染 旧标签 */}
					{renderTags(false, index)}
					{/* 渲染 手动打上去的标签 */}
					{renderTags(true, index)}
				</li>
			)),
		[tags, item, state.insGroup]
	);
	// return newTags.map((v, index) => (
	// 	<li key={index}>
	// 		{/* 渲染 旧标签 */}
	// 		{renderTags(false, index)}
	// 		{/* 渲染 手动打上去的标签 */}
	// 		{renderTags(true, index)}
	// 	</li>
	// ));
};

export default RenderListItem;
